export default {
  namespaced: true,
  state() {
    return {
      info: {},
      isTheHeaderShown: !process.env.VUE_APP_IS_PUBLIC,
      shouldReloadHeaderItems: false,
      isTheHeaderSearchHidden: false,
      isTheHeaderMenuHidden: false,
      isHomeLinkDisabled: false,
      vuePagePrefixes: ['app', 'public-site', 'portal', 'search', 'develop', 'report', 'admin', 'super-admin', '_debugbar', 'home', 'login', 'access-denied', 'page-not-found', 'entity-not-found', 'course-map', 'communities']
    }
  },
  getters: {
    isNotBetweenFirstAndLastDays: (state) => (date) => {
      if (state.info && state.info.firstDay && state.info.lastDay) {
        return date < new Date(state.info.firstDay) || date > new Date(state.info.lastDay)
      }
      return false
    },
    hiddenSectionCourseMapText: state => state.info && state.info.hiddenSectionCourseMapText,
    currentYearId: state => state.info && state.info.yearId,
    isSingleYearSchoolTerm: state => state.info && state.info.isSingleYearSchoolTerm,
    isUserSuperAdmin: state => state.info && state.info.user && state.info.user.isSuperAdmin,
    isUserAdmin: state => state.info && state.info.user && state.info.user.isAdmin,
    isUserLessonManager: state => state.info && state.info.user && state.info.user.isLessonManager,
    userTeacherId: state => state.info && state.info.teacherId,
    isCourseMapDescriptionVisible: state => state.info && state.info.isCourseMapDescriptionVisible,
    courseMapDescriptionDefault: state => state.info && state.info.courseMapDescriptionDefault,
    // Shows if we should hide the names of months in the head of unit calendar year view
    isHideMonthsLinesUnitBasedEditCalendar: state => state.info && state.info.isHideMonthsLinesUnitBasedEditCalendar,
    firstDayOfWeek: state => (state.info && state.info.firstDayOfWeek) || 'Mon',
    isAdoptedCurriculum: state => state.info && state.info.isAdoptedCurriculum,
    masterMapType: state => state.info && state.info.masterMapType,
    adoptedCurriculumMapType: state => state.info && state.info.adoptedCurriculumMapType,
    adoptedCurriculumMapTypeDescription: state => state.info && state.info.adoptedCurriculumMapTypeDescription,
    adoptedCurriculumMapTypeMarker: state => state.info && state.info.adoptedCurriculumMapTypeMarker,
    googleAllowed: state => state.info && state.info.googleAllowed,
    isPublicUser: () => Boolean(process.env.VUE_APP_IS_PUBLIC),
    publicSiteSettings: state => state.info && state.info.publicSiteSettings,
    publicSiteDomain: state => state.info && state.info.publicSiteDomain,
    isPublicSiteEnabled: state => state.info && state.info.isPublicSiteEnabled,
    firstDayOfAcademicCalendar: state => state.info && state.info.firstDay,
    lastDayOfAcademicCalendar: state => state.info && state.info.lastDay,
    isLessonEnabled: state => state.info && state.info.isLessonEnabled,
    isLessonUserGroupsEnabled: state => state.info && state.info.lessonUserGroupsEnabled,
    asyncCoursesURL: state => (state.info && state.info.asyncCoursesURL) || '',
    backLink: state => state.info && state.info.backLink,
    identityServerAddress: state => state.info && state.info.identityServerAddress,
    onlyShowUnitsInPublicSite: state => state.info && state.info.onlyShowUnitsInPublicSite,
    useAssessmentType: state => state.info && state.info.useAssessmentType,
    showAssessmentOppsPublic: state => state.info && state.info.showAssessmentOppsPublic,
    rteFontFaceEnabled: state => state.info && state.info.rteFontFaceEnabled,
    rteFontSizeEnabled: state => state.info && state.info.rteFontSizeEnabled,
    displayStandardDescription: state => state.info && state.info.displayStandardDescription,
    expandedStandardDescription: state => state.info && state.info.expandedStandardDescription,
    standardDescriptionTooltipText: state => (state.info && state.info.standardDescriptionTooltipText) || '',
    standardSubjectLabel: state => (state.info && state.info.standardSubjectLabel) || 'Subject',
    standardGradeLabel: state => (state.info && state.info.standardGradeLabel) || 'Grade',
    standardStrandLabel: state => (state.info && state.info.standardStrandLabel) || 'Strand',
    languages: state => state.info?.languages,
    premiumLessonEnabled: state => Boolean(state.info && state.info.premiumLessonEnabled),
    premiumApprovedExampleLessonSettings: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples) || null,
    // AEL -> Approved Example Lesson(s)
    premiumAELEditorsMarkEnabled: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples && state.info.premiumLessonSettings.approvedExamples.approvedExampleLessonAllowEditorsToMark) || false,
    approvedExampleLessonSettings: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples) || null,
    lessonApprovedExampleName: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples && state.info.premiumLessonSettings.approvedExamples.lessonApprovedExampleName) || 'Approved Example Lesson(s)',
    lessonApprovedExampleLabel: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples && state.info.premiumLessonSettings.approvedExamples.lessonApprovedExampleLabel) || 'A',
    approvedExampleLessonAdditional: state => (state.info && state.info.premiumLessonSettings && state.info.premiumLessonSettings.approvedExamples && state.info.premiumLessonSettings.approvedExamples.approvedExampleLessonAdditional) || null,
    archiveDate: state => (state.info && state.info.archiveDate),
    showArchivingAlertPost: state => (state.info && state.info.showPostArchiveAlert) || false,
    showArchivingAlertPre: state => (state.info && state.info.showPreArchiveAlert) || false,
    previousYearDescription: state => state.info && state.info.previousYearDescription,
    currentYearDescription: state => state.info && state.info.currentYearDescription,
    aiEnabled: state => state?.info?.enableAI,
    isLessonAiEnabled: state => state?.info?.enableLessonAI,
    mapTypesEnabled: state => state?.info?.mapTypesEnabled,
    useStandardsProficiencies: state => state?.info?.useStandardsProficiencies || false,
    oneRosterSync: state => state?.info?.oneRosterSync || false,
    maxProficienciesCount: state => state?.info?.maxProficienciesCount,
    userFirstName: state => state.info?.user?.isTestDriveUser ? state.info?.user?.actualFirstName.trim() : state.info?.user?.FirstName.trim(),
    userLastName: state => state.info?.user?.isTestDriveUser ? state.info?.user?.actualLastName.trim() : state.info?.user?.LastName.trim(),
    monthWeeksAcademicCalendarRelation: state => state.info.monthWeeksAcademicCalendarRelation || {},
    faifUrl: state => state.info?.faifUrl || 'https://ai.fariaedu.com',
    lessonsTeacherShareAndGoogleClassroomEnabled: state => state.info?.lessonsTeacherShareAndGoogleClassroomEnabled,
    pendingJoinRequestEnabled: state => state.info?.pendingJoinRequestEnabled,
    courseDefaultView: state => state?.info?.courseDefaultView, // "byYear", "byMonth", "coursePlan"
    unitDefaultView: state => state?.info?.unitDefaultView, // "unitPlan", "unitLesson"
    lessonAssessmentsEnabled: state => state.info?.lessonAssessmentsEnabled
  },
  mutations: {
    SET_HEADER_ITEMS_SHOULD_BE_RELOADED(state, shouldReload) {
      state.shouldReloadHeaderItems = shouldReload
    },
    SET_INFO(state, payload) {
      state.info = payload
    },
    SET_THE_HEADER_VISIBILITY(state, isShown) {
      state.isTheHeaderShown = isShown
    },
    SET_THE_HEADER_SEARCH_IS_HIDDEN(state, value) {
      state.isTheHeaderSearchHidden = value
    },
    SET_THE_HEADER_MENU_IS_HIDDEN(state, value) {
      state.isTheHeaderMenuHidden = value
    },
    SET_THE_HOME_LINK_DISABLED(state, value) {
      state.isHomeLinkDisabled = value
    },
    SET_PREMIUM_APPROVED_EXAMPLE_LESSONS_SETTINGS(state, settings) {
      if (state.info?.premiumLessonSettings?.approvedExamples) {
        state.info.premiumLessonSettings.approvedExamples = { ...settings }
      }
    },
    SET_COURSE_DEFAULT_VIEW(state, value) {
      state.info.courseDefaultView = value
    },
    SET_UNIT_DEFAULT_VIEW(state, value) {
      state.info.unitDefaultView = value
    }
  }
}
